export default "__VITE_ASSET__BdDZIYCT__"